module.exports = __webpack_public_path__ + "static/blanc-6f9b1c1e04027731d937cded2423a0aa.jpg";